import React from 'react';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';

import { decorateComponent } from '../../../documentComponents';
import { TabContent } from './TabContent';

export default decorateComponent(TabContent, 'block', {
  id: 'tabContent',
  label: '탭 내용',
  allowedParent: ['tabItem'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: () => <BsCardText />,
});
